<ion-icon [name]="iconeNome" [color]="iconeCor"></ion-icon>
